<template>
  <div>
    <div class="row border-bottom mb-2" v-for="(record, index) in [...editRecords, ...(disabledRecords ?? [])]">
      <div class="p-0 col-md-2">
        <div class="created_info">
          <p>{{ $AllDivisions[record.division_id]?.title ?? record.division_id }}
            ({{ printDivisionCities(record.division_id) }})</p>
          <template v-if="record.status === 1">
            <p class="badge badge-primary">не подтверждена</p>
          </template>
          <template v-else>
            <p class="text-muted">{{ record.created_at && printDate(record.created_at) || 'новая инкассация' }}</p>
          </template>
        </div>
      </div>
      <div class="p-0 col-md-3">
        <div class="flex">
          <select @change="() => {
                record.to_user_id = null;
                record.to_division_id = null;
              }" v-if="(userReceivers ?? []).length" v-model="record.type_id" class="form-control">
            <option value="1">на дивизион</option>
            <option value="5">пользователю</option>
          </select>
          <template v-if="+record.currency_id !== $platformConstants.operationCurrency.id">
            <input type="text" class="form-control"
                   :value="Math.round(getSumByCurrency(record.sum, record.currency_id)) + ' RUB'" disabled/>
          </template>
          <input type="text" v-model="record.sum"
                 :disabled="record.readOnly || record.disabled || record.to_delete || record.status === 1"
                 placeholder="Сумма" class="form-control">
          <select v-model="record.currency_id"
                  :disabled="record.readOnly || record.disabled || record.to_delete || record.status === 1"
                  class="form-control currency_select">
            <option value="0" disabled>Выберите валюту</option>
            <option v-for="curr in $AllCurrencies" :value="curr.id"
                    v-if="record.id || $currentRole === 'admin' || allowCurrencies.includes(+curr.id)"
            >{{ curr.currency }}
            </option>
          </select>
        </div>
      </div>
      <div class="p-0 col-md-4">
        <input type="text" v-model="record.comment" :disabled="record.readOnly || record.disabled || record.to_delete"
               placeholder="Комментарий" class="form-control">
      </div>
      <div class="col-md-3 flex flex_gap_10 p-0">
        <template
          v-if="(+record.type_id === 1 && +record.division_id === +division) || (+record.type_id === 5 && record.user_id === $currentUID) || record.readOnly">
          <div class="p-0 w-100">
            <div class="flex justify-content-between">
              <template v-if="+record.type_id === 5">
                <select v-model="record.to_user_id" class="form-control">
                  <option :value="null" disabled>Выберите получателя</option>
                  <option v-for="id in (userReceivers ?? [])" :value="id">
                    <UserName :id="id"/>
                  </option>
                </select>
              </template>
              <template v-else>
                <template v-if="!(receivers ?? []).length">
                  <div class="align-self-center pl-1">
                    <UserName :id="record.to_user_id" v-if="record.to_user_id"/>
                    <p>{{ $AllDivisions[record.to_division_id]?.title }}</p>
                  </div>
                </template>
                <template v-else>
                  <select v-model="record.to_division_id"
                          :disabled="record.to_delete || record.status === 1 || record.disabled"
                          class="form-control">
                    <option v-for="receiver in receivers" :value="receiver.id">
                      {{
                        receiver.id === 0 ? 'Администрация' : receiver.title + ' (' + receiver?.user?.short_name + ')'
                      }}
                    </option>
                    <template v-if="record?.id">
                      <option v-for="r in getSavedReceivers()" v-if="r" :value="r.id">
                        {{ r.title + ' (' + r?.user?.short_name + ')' }}
                      </option>
                    </template>
                  </select>
                </template>
              </template>
              <button v-if="$currentRole === 'admin' || (record.user_id === $currentUID && !record.is_confirmed)"
                      @click="record.to_delete = !record.to_delete"
                      class="btn btn-danger"><i
                class="icon-fa icon-fa-remove"></i></button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="p-l-5 align-self-center">
            Входящая инкассация
            <div v-if="record.type_id === 5">
              <UserName :id="record.user_id"/>
            </div>
          </div>
        </template>
        <!--        <div v-if="record.is_confirmed !== 2 && $currentUID !== record.user_id" class="align-self-end">-->
        <!--          <LoadingButton-->
        <!--            title="подтвердить"-->
        <!--            className="btn btn-outline-success"-->
        <!--            :onClick="() => {}"-->
        <!--            :loading="loadingConfirmBtns[record.id]"-->
        <!--            :color="$constants.LOADING_COLOR"-->
        <!--          />-->
        <!--        </div>-->
      </div>
      <div class="col-md-2 p-0" v-if="$currentRole === 'admin'">
        <p><label class="mb-0"><input
          :disabled="record.readOnly ?? (record.created_by && record.created_by !== $currentUID)" type="checkbox"
          @change="useTrader(index)"
          v-model="record.data.by_trader"> Через обменник</label></p>
      </div>
      <template v-if="record.data.by_trader">
        <div class="col-md-3 p-0">
          <div class="flex">
            <input type="number" @change="updateRecordRate(index)" class="form-control"
                   :disabled="record.readOnly"
                   v-model="record.data.converted_sum" placeholder="Сумма в USDT">
            <input type="text" :disabled="record.readOnly" v-model="record.data.rate" placeholder="Курс" disabled
                   class="form-control">
          </div>
        </div>
        <template v-if="$currentRole === 'admin'">
          <div class="col-md-4 p-0 flex">
            <input type="text" v-model="record.data.receive_address" placeholder="Куда"
                   :disabled="record.readOnly" class="form-control">
            <input type="text" v-model="record.data.send_address" placeholder="Откуда"
                   :disabled="record.readOnly" class="form-control">
          </div>
          <div class="col-md-3 p-0">
            <input type="text" v-model="record.data.aml_risk" placeholder="AML Risk"
                   :disabled="record.readOnly" class="form-control">
          </div>
        </template>
      </template>
    </div>
    <div class="flex justify-content-between p-t-10">
      <button v-if="(receivers ?? []).length || (userReceivers ?? []).length" @click="addNew()" class="btn btn-info">
        Добавить инкассацию
      </button>
      <vue-ladda @click="save" button-class="btn btn-success"
                 data-style="zoom-in"
                 :loading="loading">Сохранить инкассации
      </vue-ladda>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import {diff} from 'deep-object-diff';
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import UserName from "@/components/users/UserName.vue";

export default {
  props: [
    'currencies', 'useConfirm', 'receivers', 'userReceivers', 'records', 'date', 'division', 'userId', 'updateRecords', 'updateReport', 'users', 'disabledRecords'
  ],
  components: {
    UserName,
    LoadingButton,
    VueLadda,
  },
  data() {
    return {
      loading: false,
      loadingConfirmBtns: {},
      editRecords: [],
      allowCurrencies: [],
    }
  },
  watch: {
    'records': {
      handler: function (val) {
        this.cloneRecords();
      }
    },
    'editRecords': {
      handler: function (val, oldVal) {
        val.forEach((obj, key) => {
          const changes = diff(obj, this.editRecords[key]);
          if (changes && Object.keys(changes).length) {
            this.editRecords[key].changed = true;
          }
        });
      },
      deep: true
    },
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  async mounted() {
    this.allowCurrencies = this.$UserDetails.find((d) => d.alias === 'allowed_expenses_currencies')?.details ?? [];
    this.cloneRecords();
  },
  methods: {
    getSavedReceivers() {
      const receiverIds = this.records.reduce((acc, r) => {
        if (r.id) acc[r.to_division_id] = true;
        return acc
      }, {})
      const receivers = [];
      Object.keys(receiverIds).forEach((id) => {
        if (this.receivers.find((r) => r.id === id)) return;
        receivers.push(this.$AllDivisions[id]);
      });
      return receivers;
    },
    useTrader(index) {
      if (this.editRecords[index].data.by_trader) {
        this.editRecords[index].to_division_id = 0;
      }
    },
    updateRecordRate(i) {
      this.editRecords[i].data.rate = Math.round((this.editRecords[i].sum ?? 0) / (this.editRecords[i].data.converted_sum ?? 0) * 100) / 100;
    },
    cloneRecords() {
      this.editRecords = [];
      if (this.records) {
        this.records.forEach((e) => this.editRecords.push({
          ...e,
          data: e.data ?? {rate: ''},
          to_delete: false,
          disabled: +e.to_division_id === +this.division || (this.$currentUID !== e.user_id && this.$currentRole !== 'admin') || (this.$currentRole !== 'admin' && !!e.is_confirmed)
        }));
      }
    },
    addNew(minSum = 0, toConfirm = false) {
      this.editRecords.push({
        id: null,
        sum: 0,
        type_id: 1,
        division_id: this.division,
        report_date: this.date,
        to_division_id: this.getDefaultReceiver(),
        to_user_id: 0,
        currency_id: 33,
        comment: null,
        data: {rate: ''},
        user_id: this.userId,
        to_delete: false,
        is_confirmed: this.$currentRole === 'admin' ? 1 : 0
      })
    },
    getDefaultReceiver() {
      if (+this.division === 1) {
        const a = this.receivers.find((r) => r.id === 0)
        return a ? 0 : this.receivers[0]?.id;
      }
      return this.receivers[0]?.id;
    },
    printDivisionCities(divId) {
      let text = '';
      (this.$AllDivisions[divId]?.cities ?? []).forEach((c, i) => {
        if (i !== 0) text += ', ';
        text += c.city.short_name;
      })
      return +divId === 0 ? 'Администрация' : text;
    },
    async save() {
      if (!this.editRecords || !this.editRecords.length) return;
      if (this.editRecords.find((r) => +r.type_id === 5 && !r.to_delete && !r.to_user_id)) {
        toastr['warning']('получатель не выбран', 'Ошибка!');
        return;
      }
      if (this.editRecords.find((r) => !r.to_delete && !r.sum)) {
        toastr['warning']('укажите сумму', 'Ошибка!');
        return;
      }
      this.loading = true;
      const {data} = await api.post('/reports/updateReport', {
        type: 'incomes',
        records: this.editRecords,
        division: this.division,
        date: this.date
      });

      if (data.success) {
        if (this.updateRecords) {
          this.updateRecords(data.records);
        }
        if (this.updateReport) {
          await this.updateReport();
        }
        toastr['success']('Сохранено!');
      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.loading = false;
    },
    checkSum(record, index) {
      if (record.minSum) {
        if (record.sum < record.minSum) {
          this.editRecords[index].sum = record.minSum;
          toastr['warning']('Сумма не может быть меньше рекомендованной');
        }
      }
    }
  }
}

</script>

<style scoped>
.row select,
.row input,
.row button {
  border-radius: 0;
}

i {
  text-align: center;
}

.row {
  padding: 2px 16px;
}

.row p {
  font-size: 10px;
  margin-bottom: 2px;
}

.created_info {
  width: 125px;
  padding-right: 5px;
  padding-top: 5px;
}

.created_info p {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
